import React from "react";
import { Modal, Spin } from "antd";
import svg18 from "../assets/svg/svg18.svg";
import svg28 from "../assets/svg/svg28.svg";

const ConfirmModal = ({
  open,
  handleCancel,
  handleSubmit,
  loading,
  content,
  type,
  btnTitle,
}) => {
  return (
    <>
      <Modal
        className="!w-[31.6875rem]"
        title="Confirm Action"
        open={open}
        onOk={handleSubmit}
        onCancel={handleCancel}
      >
        <div className="my-[2.69rem] flex items-center justify-center gap-x-[2.69rem]">
          {type == "alert" ? (
            <img src={svg28} alt="svg28" />
          ) : (
            <img src={svg18} alt="svg18" />
          )}

          <span className="details_h">{content}</span>
        </div>

        <div className="flex justify-end items-center  gap-x-[.75rem]">
          <div className="w-[100px]">
            <button className="cstm-btn " onClick={handleCancel}>
              Cancel
            </button>
          </div>

          <div className="w-[150px]">
            <button
              disabled={loading}
              className={`cstm-btn-2 ${
                type === "alert" ? "!bg-[#B42318]" : "inherit"
              }`}
              onClick={handleSubmit}
            >
              {loading ? <Spin /> : btnTitle}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default ConfirmModal;
